<template>
  <div class="stretch">
    <div class="title-padding">
      <el-button
        type="default"
        size="small"
        class="action"
        :disabled="true"
      >
        Regenerate SSL certificates
      </el-button>

      <el-divider content-position="left">
        <h3>Domain names</h3>
      </el-divider>
    </div>

    <el-table
      v-if="domains.length > 0"
      ref="domain"
      :data="domains"
      size="mini"
    >
      <el-table-column width="24px" />

      <el-table-column label="Domain" prop="name" />

      <el-table-column label="Status" width="250px">
        <template slot-scope="scope">
          <div v-if="!scope.row.root">Pending ...</div>

          <div v-else-if="application.publicIp && scope.row.ips.indexOf(application.publicIp) !== -1" class="success">
            <i class="el-icon-success" />
            Point to application ip {{ application.publicIp }}
          </div>

          <div v-else-if="scope.row.ips.indexOf(instance.publicIp) !== -1" class="success">
            <i class="el-icon-success" />
            Point to server ip {{ instance.publicIp }}
          </div>

          <div v-else-if="scope.row.proxy === instance.publicIp" class="proxy">
            <i class="el-icon-right" />
            Proxy to server ip {{ instance.publicIp }}
          </div>

          <div v-else class="failure">
            <i class="el-icon-error" />
            Not connected to {{ instance.publicIp }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Expiration Date" prop="expiration">
        <template v-if="scope.row.expiration" slot-scope="scope">
          <el-tag
            v-if="scope.row.root !== scope.row.name"
            type="primary"
            size="mini"
          >
            {{ scope.row.root }}
          </el-tag>
          {{ toCalendar(scope.row.expiration) }}
        </template>
      </el-table-column>

      <el-table-column align="right">
        <template slot-scope="scope">
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click="remove(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <el-card shadow="hover">
      <DomainConnect
        ref="connect"
        :loading="loading"
        :connect.sync="form.domains"
        placeholder="Choose a domain name to connect on your application (runstack.com, etc.)"
        use-cancel
      />

      <el-button
        v-if="form.domains.length > 0"
        type="primary"
        size="large"
        :loading="loading"
        @click.prevent="connect"
      >
        Connect domain
      </el-button>
    </el-card>
  </div>
</template>

<script>
import DomainConnect from '../Domain/Connect'

export default {
  props: {
    application: Object,
    instance: Object,
    domains: Array
  },
  components: {
    DomainConnect
  },
  data () {
    return {
      loading: false,
      form: {
        domains: []
      }
    }
  },
  methods: {
    remove (domain) {
      this.$confirm('Remove domain name from this application ?', 'Warning', {
        confirmButtonText: 'Remove ' + domain.name,
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(() => this.$store.dispatch('removeDomain', {
        id: domain.id,
        name: domain.name,
        applicationId: this.application.id,
        instanceId: this.application.instanceId
      })).catch(() => {})
    },
    connect () {
      this.loading = true
      this.$store.dispatch('createDomain', {
        applicationId: this.application.id,
        instanceId: this.application.instanceId,
        ...this.form
      }).then(() => {
        this.loading = false
        this.$refs.connect.cancel()
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../theme";

.el-table {
  margin-top: 12px;
  margin-bottom: 30px;
}
.el-card {
  margin: 50px 24px 0;
  padding-top: 5px;

  .el-button {
    display: block;
    margin: 35px auto 20px;
  }
}
.success {
  color: $--color-success;
}
.proxy {
  color: $--color-primary;
}
.failure {
  color: $--color-danger;
}
</style>
